/* eslint-disable indent */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useCallback, useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { useLocation, useNavigate } from "react-router-dom";
import Moment from "react-moment";
import API from "../../../api";
import urls from "../../../api/urls";

import {
  getStartAndEndDate,
  getCreatedDateNEnd,
  dateFormat_dmy,
  dateFormat_ymd,
  capitaliseWithHyphen,
  scrollToTop,
  formatReceiverAddress,
  splitReceiverName,
  getCurretRole,
  printingFileTemplate,
  capitalise,
  capitalize,
  firstLetterCapitaliseStr,
} from "../../../utils";
import {
  Col,
  Row,
  Select,
  Menu,
  Dropdown,
  Spin,
  Input,
  Button,
  message,
  DatePicker,
  Form,
  Divider,
} from "antd";
import { FilterFilled } from "@ant-design/icons";
import moment from "moment";
import axios from "axios";

import { shallowEqual, useDispatch, useSelector } from "react-redux";
import DraggerModal from "../modals/draggerModal";
import ViewBookingSummaryEdit from "../../ViewBookingSummaryEdit";
import ViewBookingSummary from "../../ViewBookingSummary";
import {
  getBarcodeId,
  getSingleBooking,
} from "../../../actionsMethods/cashBookingMethods";
import { column } from "./column";
import TableContainer from "../../../components/TableContainer";
import search_icon from "../../../assests/images/search-icon.svg";
import truck from "../../../assests/images/SVG/packetSurface.svg";
import plane from "../../../assests/images/planeicon.svg";
import print_icon from "../../../assests/images/master/print.svg";
import print_icon_white from "../../../assests/images/master/print-white.svg";

import Smcs_Loader from "../../../assests/images/loader-new.gif";

import filter_icon from "../../../assests/images/master/sorting-filter.svg";
import Dox from "../../ViewBookingSummary/Dox";
import PrintBooking from "../../PrintBooking";
import Filters from "./Filters";
import constants from "../../../constants/constants";
import useCustomNavigate from "../../../components/customNavigationHook";
import { convertCurrentToPrevBookingData } from "../../../utils/bookingDataConverter";
import Heading from "../../../components/Heading";

const {
  UPLOAD_MANIFEST_FILE,
  GET_DOCUMENT_DETAILS_BY_AWB,
  GET_DOCUMENT_DETAILS_BY_AWB_CLIENT,
  GET_SINGEL_DOCUMENT_DETAILS_AWB,
  GET_SINGEL_DOCUMENT_DETAILS_AWB_BE,
  CANCEL_BOOKING,
  GET_CLIENT_INNO,
  GET_CLIENT_LIST_NEW,
  FETCH_CLIENT_RATE_EDIT,
  NBA_EXPORT_BOOKING_DATA,
} = urls;
const { RangePicker } = DatePicker;

const BookingTable = ({ userList }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useCustomNavigate();
  const history = useLocation();

  const [data, setData] = useState([]);
  const [oldAwbNum, setOldAwbNum] = useState(null);
  const [uploadModalvisible, setUploadModalvisible] = useState(false);
  // const [inputSearchValue, setInputSearchValue] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSummaryModalOpen, setIsSummaryModalOpen] = useState(false);
  const [bookingType, setBookingType] = useState("");

  const backHistory = history?.state?.credit;

  const [pageNum, setPageNum] = useState(
    backHistory ? history?.state?.pageNo : 0
  );
  const [pageSize, setPageSize] = useState(
    backHistory ? history?.state?.pageSize : 20
  );
  const [currentPage, setCurrentPage] = useState(
    backHistory ? history?.state?.pageNo + 1 : 1
  );

  const debounceTimeout = useRef(null);
  const [searchValue, setSearchValue] = useState(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filteredInfo, setFilteredInfo] = useState(null);
  const [printer, setPrinter] = useState(null);
  const [clientList, setClientList] = useState([]);
  const [department, setDepartment] = useState([]);
  const [clientId, setClientID] = useState(null);
  const [departId, setDepartID] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [printDoc, setPrintDoc] = useState(null);
  const [printMultiDoc, setPrintMultiDoc] = useState([]);
  const currentEnv = process.env.REACT_APP_ENV;
  const [dateRange, setDateRange] = useState(
    backHistory
      ? history?.state
      : {
          startDate: moment().format(dateFormat_dmy),
          endDate: moment().format(dateFormat_dmy),
        }
  );
  const [documentDetails, setDocumentDetails] = useState([]);

  const [creditCharges, setCreditCharges] = useState(0);

  const selectedCompany =
    JSON.parse(localStorage.getItem("selectedCompany")) || null;

  const componentRef = useRef();
  const [printTrue, setPrintTrue] = useState(false);

  const { CLIENT_ADMIN } = constants?.ROLES;

  const [allFilters, setAllFilters] = useState({
    pageNo: null,
    pageSize: null,
    startDate: null,
    endDate: null,
    search: null,
    bookingType: "credit",
    status: null,
    docType: null,
    serviceType: null,
    travelBy: null,
    client: null,
    userSeleted: null,
    bulkPrint: null,
  });

  const exportData = async (filterData) => {
    let url = `${NBA_EXPORT_BOOKING_DATA}`;

    if (selectedCompany?.key) {
      url += `?companyId=${selectedCompany?.key}`;
    }

    if (filterData?.userSeleted) {
      let temp = userList.find((val) => val.key == filterData?.userSeleted);
      url += `&usernames=${temp?.text}`;
    }

    if (filterData?.startDate) {
      const start = moment(filterData.startDate, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      );
      const end = moment(filterData.endDate, "DD-MM-YYYY").format("YYYY-MM-DD");

      url += `&updatedAtStart=${start}&updatedAtEnd=${end}`;
    }

    if (filterData?.bookingType) {
      url += `&bookingType=${
        filterData?.bookingType == "retail" ? "retail" : "credit"
      } `;
    }
    if (filterData?.client) {
      url += `&clientId=${filterData?.client}`;
    }

    if (filterData?.status) {
      url += `&status=${
        filterData?.status?.toLowerCase() == "booked" ? "BOOKED" : "DELIVERED"
      }`;
    }

    if (filterData?.docType) {
      url += `&shipmentType=${filterData?.docType?.toUpperCase()}`;
    }

    if (filterData?.serviceType) {
      const serviceType = filterData?.serviceType?.toLowerCase();

      let deliveryPromise = "";

      if (serviceType?.includes("vayu")) {
        deliveryPromise = serviceType?.includes("pro")
          ? "vayuQuickPro"
          : filterData?.serviceType;
      } else if (serviceType?.toLowerCase()?.includes("value plus")) {
        deliveryPromise = "valuePlus";
      } else if (serviceType?.toLowerCase()?.includes("fast track")) {
        deliveryPromise = "Fastrack";
      } else {
        deliveryPromise = firstLetterCapitaliseStr(filterData.serviceType);
      }

      url += `&deliveryPromise=${deliveryPromise}`;
    }

    if (filterData?.travelBy) {
      url += `&travelBy=${firstLetterCapitaliseStr(filterData?.travelBy)}`;
    }

    const response = await axios.get(url, {
      responseType: "blob",
    });

    const downLinkurl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = downLinkurl;
    link.setAttribute("download", "shipments.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  useEffect(() => {
    const { state } = history || {};

    if (backHistory) {
      setAllFilters({ ...state, client: state?.departId || state?.client });
      getAllBookings({ ...state, client: state?.departId || state?.client });
      setFilteredInfo({
        travelBy: state?.travelBy ? [state?.travelBy] : [],
        bookingStatus: state?.status ? [state?.status] : [],
        userName: state?.userSeleted,
        type: [state?.docType, state?.serviceType], // Removes null/undefined values
      });
      // setClientID(state.client);
    }
  }, [history]);

  useEffect(() => {
    let temp = {
      pageNo: pageNum,
      pageSize: pageSize,
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
      search: searchValue,
      bookingType: "account",
      status: null,
      docType: null,
      serviceType: null,
      travelBy: null,
      client: clientId,
      userSeleted: null,
    };
    setAllFilters(temp);
    if (!backHistory) {
      getAllBookings(temp);
    }
  }, []);

  const [selectedClientNDeapart, setSelectedClientNDeapart] = useState(null);

  const userId = JSON.parse(localStorage.getItem("userId"));

  function convertNewToOldData(newData) {
    if (!newData?.data?.items) return null;

    return {
      surfaceShipmentNo: null,
      airShipmentNo: null,
      surfaceShipmentWeight: null,
      atrShipmentWeight: null,
      surfaceVolWeight: null,
      airVolWeight: null,
      totalCount: newData.data.count,
      totalPages: newData.data.totalPages,
      viewBookings: newData.data.items.map((item) => ({
        awbNumber: parseInt(item.documentNo),
        bookingTime: item.createdAt,
        bookingType: item.bookingType,
        bookingStatus: item.status,
        serviceType: item.deliveryPromise,
        weight: item.dwsWeight,
        travelBy: item.travelBy,
        location: null,
        volumetricWeight: +item.volumentricWeight,
        type: item.shipmentType,
        toCenter: item.receiverAddress?.city || null,
        senderName: item.pickupAddress?.name || null,
        receiverName: item.receiverAddress?.name || null,
        clientName: null,
        userId: null,
        userName: item.username,
        length: parseFloat(item.dwsLength) || 0,
        width: 0,
        height: parseFloat(item.dwsHeight) || 0,
        childCount: item.childCount,
        senderMobileNumber: parseInt(item.pickupAddress?.phone) || null,
        receiverMobileNumber: parseInt(item.receiverAddress?.phone) || null,
        frightCharges: null,
        packegingCharge: 0,
        totalCharge: item?.charges?.totalCharge || null,
        isAudited: null,
        auditedWeight: parseFloat(item.auditedWeight) || null,
        invoiceNumber: item.metadata?.invoiceNo,
        modeOfPayment: item?.charges?.mode || null,
      })),
    };
  }

  const getAllBookings__ = async ({
    pageNo,
    pageSize,
    startDate,
    endDate,
    search,
    bookingType = "account",
    status,
    docType,
    serviceType,
    travelBy,
    client,
    userSeleted,
    bulkPrint,
  }) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    setLoading(true);
    let url =
      `${GET_DOCUMENT_DETAILS_BY_AWB}?pageNo=${pageNo}&pageSize=${pageSize}` +
      getStartAndEndDate(
        startDate ? startDate : null,
        endDate ? endDate : null,
        dateFormat_dmy
      );

    let data = "account";

    if (selectedCompany?.key) {
      url += `&branchId=${selectedCompany?.key}`;
    }

    if (data) {
      url += `&bookingType=${"account"}`;
    }

    if (status) {
      url += `&bookingStatus=${
        status?.toLowerCase() == "booked" ? "completed" : status?.toLowerCase()
      }`;
    }

    if (search) {
      url += `&awbNumber=${search}`;
    }

    if (docType) {
      url += `&type=${docType?.toLowerCase()}`;
    }
    if (serviceType) {
      url += `&serviceType=${serviceType?.toLowerCase()}`;
    }
    if (travelBy) {
      url += `&travelBy=${travelBy?.toLowerCase()}`;
    }
    if (client) {
      url += `&clientId=${client}`;
    }

    let response;

    if (userSeleted) {
      response = await API.Api(url).getCustomHeader({
        "USER-ID": userSeleted,
        "SMCS-PREMISE-ID": userId?.userInfo?.premiseId,
      });
    } else {
      response = await API.Api(url).getWithPremiseHeader();
    }
    if (response?.status) {
      setLoading(false);
      let res = response?.response?.data;
      let temp = res?.viewBookings?.map((obj) =>
        obj.bookingStatus === "COMPLETED"
          ? {
              ...obj,
              bookingStatus: "BOOKED",
              disabled: obj?.bookingType?.toUpperCase() === "CASH",
            }
          : { ...obj, disabled: obj?.bookingType?.toUpperCase() === "CASH" }
      );

      let response1Data = { ...res, viewBookings: temp };
      let result = sanitizeData(response1Data);
      if (bulkPrint) {
        setSelectedRowKeys(temp.map((e) => e.awbNumber));
      }
      setData(result);
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  const getAllBookings = async ({
    pageNo,
    pageSize,
    startDate,
    endDate,
    search,
    bookingType = "account",
    status,
    docType,
    serviceType,
    travelBy,
    client,
    userSeleted,
    bulkPrint,
  }) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    // console.log(pageNo + 1, "pageNo");
    // console.log(history?.state?.pageNo, "history");
    setLoading(true);
    let url =
      `${GET_DOCUMENT_DETAILS_BY_AWB_CLIENT}?limit=${pageSize}&page=${
        pageNo + 1
      }` +
      getCreatedDateNEnd(
        startDate ? startDate : null,
        endDate ? endDate : null,
        dateFormat_ymd
      );

    let data = "account";

    // if (selectedCompany?.key) {
    //   url += `&companyId=${selectedCompany?.key}`;
    // }

    // if (data) {
    //   url += `&bookingType=${"credit"}`;
    // }

    if (status) {
      url += `&status=${
        status?.toLowerCase() == "booked" ? "completed" : status?.toLowerCase()
      }`;
    }

    if (search) {
      url += `&documentNos=${search}`;
    }

    if (docType) {
      url += `&shipmentType=${docType}`;
    }
    if (serviceType) {
      url += `&deliveryPromise=${serviceType}`;
    }
    if (travelBy) {
      url += `&travelBy=${travelBy}`;
    }
    if (client) {
      url += `&clientId=${client}`;
    }

    let response;

    if (userSeleted) {
      response = await API.Api(url).getCustomHeader({
        "USER-ID": userSeleted,
        "SMCS-PREMISE-ID": userId?.userInfo?.premiseId,
      });
    } else {
      response = await API.Api(url).getWithPremiseHeader();
    }
    if (response?.status) {
      setLoading(false);
      let res = response?.response?.data;

      let response1Data = convertNewToOldData(res);
      let result = sanitizeData(response1Data);

      if (bulkPrint) {
        setSelectedRowKeys(result?.viewBookings?.map((e) => e.awbNumber));
      }
      setData(result);
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  function sanitizeData(obj) {
    for (let key in obj) {
      if (
        obj[key] === null ||
        obj[key] === undefined ||
        obj[key] === "" ||
        Number.isNaN(obj[key]) ||
        obj[key] === "NaN" ||
        Number.isNaN(obj[key])
      ) {
        obj[key] = 0;
      }
    }
    return obj;
  }

  const handleUpload = useCallback((val) => {
    setUploadModalvisible(true);
    setOldAwbNum(val.awbNumber);
  });

  function handleCancel() {
    setIsModalOpen(false);
    setIsSummaryModalOpen(false);
  }

  function MyComponent(dateToFormat) {
    return (
      <>
        <Moment format="DD/MM/YYYY">{dateToFormat}</Moment>
        <br />
        <Moment format="hh:mm A">{dateToFormat}</Moment>
      </>
    );
  }

  function handleEditView(params) {
    setBookingType(params?.bookingType);
    setIsModalOpen(true);
    dispatch(getSingleBooking(params?.awbNumber));
    setBookingType(params?.bookingType);
  }

  const getClientRates = async (awbNum) => {
    setLoading(true);

    let response = await API.Api(
      `${FETCH_CLIENT_RATE_EDIT}/sevasetu-reader/shipment/${awbNum}
`
    ).getWithNoToken();

    if (response?.status) {
      setLoading(false);
      const temp = response?.response?.data?.data?.charges;
      setCreditCharges(temp);
    } else {
      setLoading(false);
      setCreditCharges(0);
    }
  };

  const handleEyeButton = (b) => {
    setBookingType(b?.bookingType);
    setIsSummaryModalOpen(true);
    if (currentEnv === "qa" || currentEnv == "prod") {
      getDetails(b?.awbNumber);
    } else {
      dispatch(getSingleBooking(b?.awbNumber));
    }
    getClientRates(b?.awbNumber);
  };

  const getDetails = async (id) => {
    setLoading(true);
    let url = `${GET_SINGEL_DOCUMENT_DETAILS_AWB_BE + +id}`;

    let response = await API.Api(url).getWithAllHeaders();
    if (response?.status) {
      setLoading(false);
      let extract = response?.response?.data?.data?.items;
      let convert = convertCurrentToPrevBookingData(extract);
      setDocumentDetails(convert);
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const statusFun = (val) => {
    const statusColors = {
      BOOKED: "stat-green",
      INITIATED: "blue",
      "In progress": "blue",
      Delivered: "stat-green",
      PACKETED: "darkBlue",
      SCANNED: "purple",
      "In transit": "yellow",
      MANIFESTED: "yellow",
      OUTSCANNED_TO_CP: "yellow",
    };

    const color = statusColors[val?.toUpperCase()] || "yellow";

    return <span className={color}>{val?.toUpperCase()}</span>;
  };

  function handleEdit(id, dateNTime) {
    localStorage.setItem("side_active", 3);

    const formattedDate = moment(dateNTime).format("DD-MM-YYYY");

    navigate(`/credit-booking-edit/${formattedDate}/${id}`, {
      state: {
        ...allFilters,
        departId: departId || history?.state?.departId,
        client: clientId || history?.state?.client,
        credit: true,
        retail: false,
      },
    });
  }

  /******************* Input search ******************************/

  const handleChangeSearch = (e) => {
    let currValue = e.target.value;
    if (currValue && isNaN(currValue)) {
      return;
    }
    setSearchValue(currValue);

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(async () => {
      let temp = {
        pageNo: 0,
        pageSize: 20,
        startDate: moment().subtract(30, "days"),
        endDate: moment(new Date(), dateFormat_dmy),
        search: currValue.length ? currValue.trim() : null,
        client: clientId,
        status: null,
        docType: null,
        serviceType: null,
        travelBy: null,
        userSeleted: null,
      };
      setAllFilters(temp);
      getAllBookings(temp);
    }, 900);
  };

  /******************* Type ******************************/

  function closeUploadModal(data) {
    setUploadModalvisible(false);
  }

  async function handleOK(data) {
    const temp = data?.map((val) => ({
      fileName: val?.response?.data?.filePath,
      fileId: val?.response?.data?.id,
    }));

    let response = await API.Api(UPLOAD_MANIFEST_FILE).postCustomHeader(temp, {
      "Awb-Number": oldAwbNum,
    });
    if (response) {
      setUploadModalvisible(false);
    }
  }

  function handlePageChange(pagination, filters, sorter) {
    setFilteredInfo(filters);
    window.scrollTo(0, 0);

    setPageSize(pagination?.pageSize);
    setPageNum(pagination?.current - 1);
    setCurrentPage(pagination?.current);

    setSearchValue(null);
    const hasFilters =
      filters?.bookingType?.[0] ||
      filters?.userName?.[0] ||
      filters?.bookingStatus?.[0] || // status
      filters?.type?.[0] ||
      filters?.type?.[1] ||
      filters?.travelBy?.[0];

    if (hasFilters) {
      setFilteredInfo(filters);
      let temp = {
        pageNo: pagination.current - 1,
        pageSize: pagination?.pageSize,
        startDate: dateRange?.startDate,
        endDate: dateRange?.endDate,
        client: clientId || history?.state?.departId || history?.state?.client,

        search: null, // search is null

        bookingType: filters?.bookingType?.[0] || null,
        status: filters?.bookingStatus?.[0] || null,
        docType: filters?.type?.[0] || null,
        serviceType: filters?.type?.[1] || null,
        travelBy: filters?.travelBy?.[0] || null,

        userSeleted: filters?.userName?.[0] || null,
      };
      setAllFilters(temp);
      getAllBookings(temp);
    } else {
      let temp = {
        pageNo: pagination?.current - 1,
        pageSize: pagination?.pageSize,
        startDate: dateRange?.startDate,
        endDate: dateRange?.endDate,
        client: clientId || history?.state?.departId || history?.state?.client,
        bookingType: null,

        search: null, // search is null

        status: null,
        docType: null,
        serviceType: null,
        travelBy: null,
        userSeleted: null,
      };
      setAllFilters(temp);
      getAllBookings(temp);
    }
  }

  // console.log(filteredInfo, "filterINFO");

  const handleGenerateManifest = () => {
    navigate("/scan", {
      state: {
        ...allFilters,
        departId: departId || history?.state?.departId,
        client: clientId || history?.state?.client,
        credit: true,
        retail: false,
      },
    });
  };

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const handleDateChange = (e, date) => {
    // e.preventDefault();
    setSearchValue(null);

    setDateRange({ startDate: date[0], endDate: date[1] });
    let temp = {
      pageNo: pageNum,
      pageSize,
      startDate: date[0] || moment(new Date(), dateFormat_dmy),
      endDate: date[1] || moment(new Date(), dateFormat_dmy),
      search: null,

      client: clientId,

      bookingType: filteredInfo?.bookingType?.[0] || null,
      status: filteredInfo?.bookingStatus?.[0] || null,
      docType: filteredInfo?.type?.[0] || null,
      serviceType: filteredInfo?.type?.[1] || null,
      travelBy: filteredInfo?.travelBy?.[0] || null,

      userSeleted: filteredInfo?.userName?.[0] || null,
    };
    getAllBookings(temp);
    setAllFilters(temp);
  };

  const handleDropdownVisibility = (visible) => {
    setDropdownVisible(visible);
  };

  // console.log(pageSize, "pageSize");

  const cancelBooking = async (awbNumber) => {
    setLoading(true);

    let response = await API.Api(
      CANCEL_BOOKING + `${awbNumber}`
    ).deleteHeader();
    if (response?.status) {
      setLoading(false);
      message.success("Booking cancelled successfully");
      let temp = {
        pageNo: pageNum,
        pageSize,
        startDate: null,
        endDate: null,
        search: searchValue,

        status: null,
        docType: null,
        serviceType: null,
        travelBy: null,
        userSeleted: null,
      };
      setAllFilters(temp);

      getAllBookings(temp);
      // handleCancelBooking();
      // setSetsubmitRespons(response);
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network error.");
    }
  };

  // const printHandle = useReactToPrint({
  //   content: () => componentRef?.current || null,
  //   onBeforePrint: () => setPrintTrue(false),
  //   onAfterPrint: () => setPrintTrue(false),
  // });

  function printCallBack(params) {
    setPrintTrue(true);
    setLoading(true);
    dispatch(getSingleBooking(params));
  }

  useEffect(() => {
    const fetchPrinter = async () => {
      try {
        // STANDARD PORT FOR ZEBRA PRINTER
        const availablePrinters = await axios.get(
          "http://localhost:9100/available"
        );
        // console.log("availablePrinters: ", availablePrinters?.data?.printer[0]);
        setPrinter(availablePrinters?.data?.printer[0] || null);
        //  REQUEST TO INITIATE PRINTER
        await axios.post("http://localhost:9100/write", "", {
          headers: {
            "Content-Type": "text/plain",
          },
        });
      } catch (err) {
        // console.log("ZEBRA PRINTER NOT FOUND ");
        return;
      }
    };
    if (!printer) {
      fetchPrinter();
    }
  }, []);

  const handlePrinting = async (payload) => {
    let currentShipment = 1;

    // Processed address fields
    const processedAddress = formatReceiverAddress(
      payload?.addressDetails?.receiverAddressLine1,
      payload?.addressDetails?.receiverAddressLine2
    );

    const receiverName = splitReceiverName(
      payload?.addressDetails?.receiverName
    );

    const serviceMap = {
      "FAST TRACK": "FST",
      STANDARD: "STD",
      "VALUE PLUS": "VPLUS",
      VAYUQUICK: "VQ",
      VAYUQUICK_PRO: "VQPRO",
    };

    const rawService = payload?.serviceDetails?.service?.toUpperCase() || "";

    const speed = serviceMap[rawService] || rawService;

    const baseData = {
      ...receiverName,
      documentNumber: payload?.awbNumber,
      bookingType:
        payload?.shipmentDetails?.type?.toLowerCase() === "dox"
          ? "DOX"
          : "NDOX",
      bookingService: speed,
      bookindTravelType:
        payload?.serviceDetails?.travelBy?.toLowerCase() === "surface"
          ? "SUR"
          : "AIR",
      currentShipment: 1, // Replace this with appropriate logic for currentShipment
      senderName: payload?.shipmentDetails?.clientName,
      receiverMobileNumber: payload?.addressDetails?.receiverMobileNumber,
      receiverCity: payload?.addressDetails?.receiverCity,
      deliveryPincode: payload?.addressDetails?.receiverPincode,
      receiverAddressLine1: processedAddress[0] || "",
      recieverAddressLine2: processedAddress[1] || "",
      recieverAddressLine3: processedAddress[2] || "",
      recieverAddressLine4: processedAddress[3] || "",
      recieverAddressLine5: processedAddress[4] || "",
      recieverAddressLine6: processedAddress[5] || "",
      recieverAddressLine7: processedAddress[6] || "",

      senderAddress:
        payload?.addressDetails?.senderAddressLine1 +
        ", " +
        payload?.addressDetails?.senderCity,
      senderMobileNumber: payload?.addressDetails?.senderMobileNumber || "",
      totalShipments:
        parseInt(payload?.childShipmentDetails?.length || "0") + 1,
    };

    const printData = async (data) => {
      setLoading(true);
      try {
        const updatedTemplate = await printingFileTemplate()
          .then((res) =>
            res?.replace(/{{(.*?)}}/g, (_, key) => {
              return data[key?.trim()] || "";
            })
          )
          .catch((err) => console.log(err));

        const printingData = JSON.stringify({
          device: printer,
          data: updatedTemplate,
        });

        await axios.post("http://localhost:9100/write", printingData, {
          headers: {
            "Content-Type": "text/plain",
          },
        });
        setLoading(false);
      } catch (err) {
        setLoading(false);
        message.error(
          <>
            Please setup your printer if not done{" "}
            <a
              href="https://drive.google.com/file/d/1md-KX58IuOhQAi7h6VHpSxpAEGhOaaQ5/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
            >
              click here
            </a>{" "}
            for more info.
          </>
        );
        // console.log(err, "UNABLE TO PRINT");
      }
    };

    // Print for the main payload
    const mainData = {
      ...baseData,
      documentNumber: payload?.awbNumber,
    };

    await printData(mainData);

    // Check and print for child shipments
    if (
      payload?.childShipmentDetails &&
      Array.isArray(payload?.childShipmentDetails) &&
      payload?.childShipmentDetails?.length > 0
    ) {
      for (const child of payload.childShipmentDetails) {
        currentShipment = currentShipment + 1;
        const childData = {
          ...baseData,
          documentNumber: child?.childAwbNumber,
          currentShipment: currentShipment,
        };
        await printData(childData);
      }
    }
  };

  const printerCallBack = async (params) => {
    setLoading(true);
    let url = `${GET_SINGEL_DOCUMENT_DETAILS_AWB + +params}`;

    let response = await API.Api(url).getWithAllHeaders();
    if (response?.status) {
      // setLoading(false);
      handlePrinting(response?.response?.data);

      return response?.response?.data;
      // setTotalLoad(response?.response?.data);
    } else {
      setLoading(false);

      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  const clearFilters = () => {
    setFilteredInfo(null);
    let temp = {
      pageNo: 0,
      pageSize: 20,
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
      search: null,
      client: clientId || history?.state?.client,

      status: null,
      docType: null,
      serviceType: null,
      travelBy: null,
      userSeleted: null,
    };
    setAllFilters(temp);
    getAllBookings(temp);
    window.history.replaceState({}, "", window.location.pathname);
  };

  const setLoadTable = (val) => {
    setLoading(val);
  };
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record.disabled,
    }),
  };

  const printHandle = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => {
      setLoading(false);
    },
    onAfterPrint: () => {
      setLoading(false);
    },
    onPrintError: () => {
      setLoading(false);
      console.error("An error occurred while printing.");
    },
  });

  const creditPrint = (id) => {
    setPrintMultiDoc([]);
    // setLoading(true);
    setPrintDoc(id);
  };

  function handlePrint() {
    let temp = {
      pageNo: pageNum,
      pageSize,
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
      search: null,
      bookingType: "account",
      status: filteredInfo?.bookingStatus?.[0] || null,
      docType: filteredInfo?.type?.[0] || null,
      serviceType: filteredInfo?.type?.[1] || null,
      travelBy: filteredInfo?.travelBy?.[0] || null,
      client: clientId,
      userSeleted: filteredInfo?.userName?.[0] || null,
      bulkPrint: "bulkprint",
    };
    getAllBookings(temp);
    setAllFilters(temp);
  }

  function handleClearSelect(params) {
    if (params == "client") {
      setClientID(null);
      setDepartment(null);
      form.setFieldsValue({ department: null });
      let temp = {
        pageNo: pageNum,
        pageSize,
        startDate: dateRange?.startDate,
        endDate: dateRange?.endDate,
        search: null,
        bookingType: "account",
        status: filteredInfo?.bookingStatus?.[0] || null,
        docType: filteredInfo?.type?.[0] || null,
        serviceType: filteredInfo?.type?.[1] || null,
        travelBy: filteredInfo?.travelBy?.[0] || null,
        client: null,
        userSeleted: filteredInfo?.userName?.[0] || null,
        bulkPrint: null,
      };

      getAllBookings(temp);
    } else {
      setDepartID(null);

      let temp = {
        pageNo: pageNum,
        pageSize,
        startDate: dateRange?.startDate,
        endDate: dateRange?.endDate,
        search: null,
        bookingType: "account",
        status: filteredInfo?.bookingStatus?.[0] || null,
        docType: filteredInfo?.type?.[0] || null,
        serviceType: filteredInfo?.type?.[1] || null,
        travelBy: filteredInfo?.travelBy?.[0] || null,
        client: clientId,
        userSeleted: filteredInfo?.userName?.[0] || null,
        bulkPrint: null,
      };

      setAllFilters(temp);
      getAllBookings(temp);
    }
  }

  const isClientAdmin = getCurretRole();

  const printerLabelCallBack = async (params) => {
    setLoading(true);
    let url = `${GET_SINGEL_DOCUMENT_DETAILS_AWB_BE + +params}`;

    let response = await API.Api(url).getWithAllHeaders();
    if (response?.status) {
      setLoading(false);
      let extract = response?.response?.data?.data?.items;
      let convert = convertCurrentToPrevBookingData(extract);
      return convert;
      // setDocumentDetails(convert);
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  const printPDFLabel = async (data) => {
    let temp = await printerLabelCallBack(data?.awbNumber);

    const serviceMap = {
      "FAST TRACK": "FST",
      FASTRACK: "FST",

      STANDARD: "STD",
      "VALUE PLUS": "VPLUS",
      VALUEPLUS: "VPLUS",
      VAYUQUICK: "VQK",
      VAYUQUICK_PRO: "VQ PRO",
      VAYUQUICKPRO: "VQ PRO",
    };

    const rawService = temp?.serviceDetails?.service?.toUpperCase() || "";

    const speed = serviceMap[rawService] || rawService;

    // console.log(temp, "temp");
    // console.log(speed, "speed");
    // console.log(
    //   temp?.shipmentDetails?.travelBy?.toUpperCase() || "",
    //   "travelBy"
    // );

    const output = {
      labels: [
        {
          mode: temp?.shipmentDetails?.travelBy?.toUpperCase() || "", // e.g., "SURFACE"
          type: temp?.shipmentDetails?.type?.toUpperCase() || "", // e.g., "DOX"
          speed: speed || "", // e.g., "VAYUQUICK" (replace logic if needed)
          qty: `${temp?.childShipmentDetails?.length || 0}/1`, // Using actual child count
          qr_code: temp?.awbNumber.toString(),
          awb_number: temp?.awbNumber.toString(),
          barcode_awb_number: temp?.awbNumber.toString(),
          to_deliver: temp?.addressDetails?.receiverName || "",
          to_mobile:
            temp.addressDetails?.receiverMobileNumber?.toString() || "",
          to_pincode: temp?.addressDetails?.receiverPincode?.toString() || "",
          to_city: temp?.addressDetails?.receiverCity || "",
          to_address: `${temp?.addressDetails?.receiverAddressLine1 || ""}, ${
            temp.addressDetails?.receiverCity || ""
          }, ${temp.addressDetails?.receiverState || ""}`,
          from_address: `${temp?.addressDetails?.senderAddressLine1 || ""}, ${
            temp?.addressDetails?.senderCity || ""
          }, ${temp?.addressDetails?.senderState || ""}`,
          from_mobile:
            temp?.addressDetails?.senderMobileNumber?.toString() || "",
        },
      ],
    };

    const url = "https://devapis.delcaper.com/gopdf/pdf/nba_label_4x6";

    try {
      setLoading(true);

      const response = await axios.post(url, output, {
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "blob",
      });

      setLoading(false);
      const blob = new Blob([response.data], { type: "application/pdf" });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${data?.awbNumber + ".pdf"}`; // You can customize the filename
      link.click();
    } catch (error) {
      setLoading(false);
      message.error(error?.response?.data?.message || "Internal server error.");
    }
  };

  return (
    <Spin
      spinning={loading}
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <div style={{ marginLeft: "15px", marginTop: "10px" }}>
        {" "}
        <Heading title="Back " />
      </div>
      <div className="print-only">
        <Dox
          // allAppData={singleResult}
          allAppData={documentDetails}
          // componentRef={componentRef}
          bookingType={bookingType}
        />
      </div>
      <ViewBookingSummary
        visible={isSummaryModalOpen}
        loading={loading}
        // handleCancelBooking={handleCancelBooking}
        handleCancel={handleCancel}
        // allAppData={currentEnv == "qa" ? documentDetails : singleResult}
        allAppData={documentDetails}
        bookingType={bookingType}
        componentRef={componentRef}
        creditCharges={creditCharges}
      />

      <DraggerModal
        oldAwbNum={oldAwbNum}
        visible={uploadModalvisible}
        handleCancel={closeUploadModal}
        handleOk={handleOK}
      />

      <div className="table-container master-main-container">
        <Row
          className="row-one align-center"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <RangePicker
            value={
              dateRange.startDate && dateRange.endDate
                ? [
                    moment(dateRange.startDate, dateFormat_dmy),
                    moment(dateRange.endDate, dateFormat_dmy),
                  ]
                : null
            }
            format={dateFormat_dmy}
            onClick={(e) => e.stopPropagation()}
            disabledDate={(current) => disabledDate(current)}
            onChange={handleDateChange}
            // format={dateFormat_dmy}
            className="input-field-style"
            style={{ width: "220px" }}
          />

          <div>
            <Input
              value={searchValue}
              placeholder="Search by doc No."
              bordered
              maxLength={16}
              onChange={(e) => handleChangeSearch(e)}
              style={{
                borderRadius: "5px",
                height: "30px",
                fontSize: "12px",
                // marginRight: "10px",
                // width: "80%",
              }}
              suffix={<img src={search_icon} />}
            />
          </div>

          <div className="generate-manifest"></div>
          <Button
            style={{ height: "28px" }}
            type="primary"
            onClick={() => {
              //navigate("/multi-print-booking", { state: selectedRowKeys })
              exportData(allFilters);
            }}
            className="btn-style"
            // disabled={selectedRowKeys.length === 0}
          >
            <img src={print_icon_white} /> <b>&nbsp;EXPORT</b>
          </Button>
        </Row>

        <TableContainer
          rowKey={(record) => record?.awbNumber}
          rowSelection={rowSelection}
          onChange={handlePageChange}
          columns={column(
            MyComponent,
            statusFun,
            handleEdit,
            handleEditView,
            handleUpload,
            handleEyeButton,
            pageSize,
            pageNum + 1,
            cancelBooking,
            printCallBack,
            printerCallBack,
            printPDFLabel,
            // handleUserFilter,

            filteredInfo,
            clearFilters,
            setLoadTable,
            creditPrint,
            userList
          )}
          scroll={{ x: 800 }}
          // showTotal={(total, range) =>
          //   `${range[0]}-${range[1]} of ${total} items`
          // }
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: data?.totalCount,
            itemRender: itemRender,
            pageSizeOptions: ["20", "50", "100"],
            showSizeChanger: true,
          }}
          dataSource={data?.viewBookings}
          headerClassName="header"
          className="view-table table-head-sticky"
        />
      </div>
      <div style={{ display: "none" }}>
        <PrintBooking
          currentDateRange={dateRange}
          ref={componentRef}
          id={printDoc}
          idList={printMultiDoc}
          loading={loading}
          setLoading={setLoading}
          callPrint={() => printHandle()}
        />
      </div>
    </Spin>
  );
};

export default React.memo(BookingTable);
